import moment from 'moment'

export const START_DATE_OF_MONTH = value => moment(value).startOf('month').format('YYYY-MM-DD').valueOf()
export const END_DATE_OF_MONTH = value => moment(value).endOf('month').format('YYYY-MM-DD').valueOf()
export const LABELMONTH = ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des']
export const LABELDAY = ['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab']
export const YEAR_MONTH_DAY = value => moment(value).format('YYYY-MM-DD')
export const DAY_MONTH_YEAR = value => moment(value).format('DD MMMM YYYY')
export const TIME_DAY_MONTH_YEAR = value => moment(value).format('HH:mm, DD MMMM YYYY')
export const DAY_MONTH_YEAR_COMMA_TIME = value => moment(value).format('DD MMMM YYYY, HH:mm')
export const TIME = value => moment(value).format('HH:mm')
export const START_YEAR_NOW = value => moment(value).startOf('year').format('YYYY').valueOf()
export const MONTH = value => moment(value).format('MM')
export const YEAR = value => moment(value).format('YYYY')
export const FULL_DATE_TIME = value => moment(value).format('DD MMMM YYYY - HH:mm')
export const DATE = value => moment(value).format('DD')
export const DDMMYYYY = value => moment(value).format('DD MMM YYYY')
export const DDMMMYYYY_12_HOURS = value => moment(value).locale('en').format('DD MMM YYYY, hh:mm:ss A')
export const YEAR_MONTH = value => moment(value).format('YYYY-MM')
export const MONTH_YEAR = value => moment(value).format('MM-YYYY')
export const LABEL_MONTH_YEAR = value => moment(value).format('MMMM - YYYY')
export const NODASH_MONTH_YEAR = value => moment(value).format('MMMM YYYY')
export const LABEL_DAY_MONTH = value => moment(value).format('DD MMMM')
export const START_FULL_DATE = value => moment(value).startOf('day').format('YYYY-MM-DD HH:mm:ss')
export const END_FULL_DATE = value => moment(value).endOf('day').format('YYYY-MM-DD HH:mm:ss')
export const START_FULL_MONTH = value => moment(value).startOf('month').format('YYYY-MM-DD HH:mm:ss')
export const END_FULL_MONTH = value => moment(value).endOf('month').format('YYYY-MM-DD HH:mm:ss')
export const DAY_MONTH_YEAR_SLASH = value => moment(value).format('DD/MMM/YYYY')
export const DDMMMMYYYY = value => moment(value).format('DD MMMM YYYY')
export const DATE_NUMBER_SLASH = value => moment(value).format('DD/MM/YYYY')
export const DATE_NUMBER_DASH = value => moment(value).format('DD-MM-YYYY')
export const DATE_NUMBER_DASH_REVERSE = value => moment(value).format('YYYY-MM-DD')
export const MONTH_NAME = value => moment(value).format('MMMM')
export const START_OF = (type, format) => moment().startOf(type).format(format)
export const END_OF = (type, format) => moment().endOf(type).format(format)
export const SUBTRACT_OF = (range, type) => moment().subtract(range, type)
export const FULL_DATE_TIME_WITH_WIB = value => `${moment(value).format('DD MMMM YYYY | HH:mm')} WIB`

/**
 * Remove UTC indicator from date string in case be forgot to manipulate date string
 * and automatically add UTC indicator
 *
 * @param {string} value - The date string to remove the UTC indicator from
 * @returns {string} The date string without the UTC indicator
 */
export const removeUTCIndicator = value => (value.endsWith('Z') ? value.slice(0, -1) : value)

/**
 * Custom date format for the date picker so the date picker
 * disabling the date of today and the future date
 *
 * @param {Object} classes - The classes object from date picker
 * @param {Date} date - The date to format from date picker
 * @returns {Object} The formatted classes object
 */
export const dateFormat = (classes, date) => {
  const newClasses = classes
  if (!newClasses.disabled) {
    // Compare only the date part, not the time
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    const compareDate = new Date(date)
    compareDate.setHours(0, 0, 0, 0)
    newClasses.disabled = compareDate >= today
  }
  return newClasses
}

/**
 * Custom date format for the date picker to disable specific dates based on a comparator function.
 * By default, it disables dates greater than today (future dates).
 *
 * @param {Function} comparator - Optional comparison function that takes (date, today) and returns boolean.
 *                               Default compares if date > today
 * @returns {Function} Formatter function that takes (classes, date) and returns modified classes
 */
export const createDatePickerRestrictor = (comparator = (date, today) => date > today) => (classes, date) => {
  const newClasses = classes
  if (!newClasses.disabled) {
    // Compare only the date part, not the time
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    const compareDate = new Date(date)
    compareDate.setHours(0, 0, 0, 0)
    newClasses.disabled = comparator(compareDate, today)
  }
  return newClasses
}
